module.exports = __webpack_public_path__ + "img/Slice38.62a5d46c.png";